import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { EditEmailDuplicateDirective } from './edit-email-duplicate.directive';

@NgModule({
  imports: [AppMaterialModule],
  exports: [EditEmailDuplicateDirective],
  declarations: [EditEmailDuplicateDirective],
  providers: []
})
export class EditEmailDuplicateModule {}
